import { ZodIssue, z } from 'zod'

export const ErrorResponseSchema = z.object({
  code: z.string(),
  businessMessage: z.string(),
  developerMessage: z.string(),
  validationErrors: z
    .any()
    .transform((x) => x as ZodIssue[])
    .optional(),
  unrecoverable: z.boolean(),
})

export type ErrorResponse = z.infer<typeof ErrorResponseSchema>
